import request from '@/utils/request'

/**
 * 查询课程
 * @param {Object} params 
 * @returns 
 */
export function listCourse(params) {
  return request({
    url: '/course/list',
    method: 'GET',
    params,
  })
}


/**
 * 查询课程
 * @param {Object} params 
 * @returns 
 */
export function authCourseList(params) {
  return request({
    url: '/course/authList',
    method: 'GET',
    params,
  })
}

/**
 * 查询课程
 * @param {Object} params 
 * @returns 
 */
export function allCourse(data) {
  return request({
    url: '/course/client/query',
    method: 'POST',
    data,
  })
}

/**
 * 添加课程
 * @param {Object} data 
 * @returns 
 */
export function addCourse(data) {
  return request({
    url: '/course/add',
    method: 'POST',
    data,
  })
}
//添加课程收藏
export function setcollect(data) {
  return request({
    url: '/course/setcollect',
    method: 'POST',
    data,
  })
}
//拷贝课程
export function copyCourse(data) {
  return request({
    url: `/course/copy/${data.id}`,
    method: 'POST',
    // data,
  })
}


/**
 * 修改课程
 * @param {Object} data 
 * @returns 
 */
export function updateCourse(data) {
  return request({
    url: '/course/update',
    method: 'PUT',
    data,
  })
}


/**
 * 删除
 * @param {Object} data 
 * @returns 
 */
export function delCourse(data) {
  return request({
    url: '/course/del',
    method: 'DELETE',
    data,
  })
}


/**
 * 删除
 * @param {Object} data 
 * @returns 
 */
export function deleteCopy(data) {
  return request({
    url: '/updatelist/deletecopy',
    method: 'POST',
    data,
  })
}



/**
 * 根据id查询课程
 * @param {Object} params 
 * @returns 
 */
export function getCourseById(id) {
  return request({
    url: '/course/getById',
    method: 'get',
    params: { id },
  })
}

export function queryAllProjectAndTask(id) {
  return request({
    url: '/course/queryAllProjectAndTask',
    method: 'get',
    params: { id },
  })
}

export function handlePPTFile(params) {
  return request({
    url: '/course/handlePPTFile',
    method: 'get',
    params,
  })
}


/**
 * 章节排序记录sortNum
 * @param {Object} data 
 * @returns 
 */
export function updateProjectSort(data) {
  return request({
    url: '/course/setProjectSort',
    method: 'POST',
    data,
  })
}

/**
 * 获取用户列表
 * @param {Object} data 
 * @returns 
 */
export function getUserList(data) {
  return request({
    url: '/course/getUserList',
    method: 'POST',
    data,
  })
}
// 邀请协作成员
export function setInvite(data) {
  return request({
    url: '/course/setInvite',
    method: 'POST',
    data,
  })
}

// 查询所有协作成员
export function queryInvite(data) {
  return request({
    url: '/course/queryInvite',
    method: 'POST',
    data,
  })
}

// 查询协作成员历史记录
export function getInviteHistory(params) {
  return request({
    url: '/course/getInviteHistory',
    method: 'get',
    params,
  })
}

// 撤回邀请协作成员
export function historyBack(data) {
  return request({
    url: '/course/historyBack',
    method: 'POST',
    data,
  })
}


